import { Routes, Route, Navigate } from "react-router-dom";
import appInfo from "./app-info";
import routes from "./app-routes";
import { SideNavOuterToolbar as SideNavBarLayout } from "./layouts";
import { LoadPanel, Toast } from "devextreme-react";
import { useSelector } from "react-redux";

export default function Content() {
  const userRole = useSelector((state) => state.auth.role);


  if (userRole === null) return <LoadPanel visible={true} />;

  return (
    <SideNavBarLayout title={appInfo.title}>
      <Routes>

        {userRole === "CCPInspector" ? (
          <Route
            path="*"
            element={<Navigate to="/quality/fillet/ccp" replace />}
          />
        ) : userRole === "QCPInspector" ? (
          <Route
            path="*"
            element={<Navigate to="/quality/fillet/qcp" replace />}
          />
        ) : userRole === "Admin" ? (
          <Route
            path="*"
            element={<Navigate to="/quality/fillet/overview" replace />}
          />
        ) : null}
        {routes.map(({ path, element, children }) => (
          <Route key={path} path={path} element={element}>
            {children &&
              children.map(({ path, element }) => (
                <Route key={path} path={path} element={element} />
              ))}
          </Route>
        ))}
        {/* <Route path="*" element={<Navigate to="/quality/fillet/overview" replace />} /> */}
      </Routes>
    </SideNavBarLayout>
  );
}
